import { render, staticRenderFns } from "./ManageQueue.vue?vue&type=template&id=b1e4fce6"
import script from "./ManageQueue.vue?vue&type=script&lang=js"
export * from "./ManageQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports